import {Component, Inject, OnInit, Input} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {GenericArray} from '../../../models/GenericArray';
import {DeltaVolumiService} from '../../monthly-actual/delta-volumi/service-delta-volumi/delta-volumi.service';
import {Subscription} from 'rxjs';
import * as toastr from 'toastr';
import {ProjectConstants} from '../../project-constants';
import {Router} from '@angular/router';
import {DeltaChargesService} from '../../monthly-charges/delta-charges/service-delta-charges/delta-charges.service';

@Component({
  selector: 'app-dialog-detail',
  templateUrl: './dialog-detail.component.html',
  styleUrls: ['./dialog-detail.component.scss']
})
export class DialogDetailComponent extends ProjectConstants implements OnInit {

  dataValues: Array<any>;
  showNotes: boolean;
  idNotes: number;
  updateNotes: Subscription;
  note: any;
  data: any;

  constructor(public dialogData: MatDialogRef<DialogDetailComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private router: Router,
              private deltaVolumiService: DeltaVolumiService,
              private deltaChargesService: DeltaChargesService) {
      super();
      this.dataValues = data.list;
      this.showNotes = false;
      if (data.note) {
        this.showNotes = true;
        this.note = data.list[0].value ;
        this.idNotes = data.discountData.id;
        this.data = data.serviceType;
      }
  }

  ngOnInit() {
  }

  save() {
    const noteObj = new Notes(this.idNotes, this.note);
    if (this.data === 'volume') {
      this.updateNotes = this.deltaVolumiService.update(this.deltaVolumiService.baseUrl, noteObj)
        .subscribe(
          (result: any) => {
            toastr.success('Note updated with success', 'Success');
            this.dialogData.close();
          }, error => {
            toastr.error('A problem has occurred, please contact the Administrator', 'Error');
          }
        );
    } else if (this.data === 'charges') {
      this.updateNotes = this.deltaChargesService.update(this.deltaChargesService.baseUrl, noteObj)
        .subscribe(
          (result: any) => {
            toastr.success('Note updated with success', 'Success');
            this.dialogData.close();
          }, error => {
            toastr.error('A problem has occurred, please contact the Administrator', 'Error');
          }
        );
    }

  }

  close() {
    this.dialogData.close();
  }

}

export class Notes {
  id: number;
  note: string;

  constructor(id: number, note: string) {
    this.id = id;
    this.note = note;
  }
}
